import * as React from 'react'
import { Edit, Labeled, ReferenceField, SimpleForm, TextField, TextInput } from 'react-admin'

import { SaveOnlyToolbar } from 'shared/react-admin'

export const SettingEdit = () => {
  return (
    <Edit redirect={false}>
      {/* <ComponentWithDynamicResourceHeader recordAttrForBreadrumb="name"> */}
      <SimpleForm toolbar={<SaveOnlyToolbar />}>
        <Labeled label="Account">
          <ReferenceField source="settable.id" reference="admin/account">
            <TextField label="Account" source="name" />
          </ReferenceField>
        </Labeled>
        <br />
        <TextInput label="Max Users" source="configuration.max_users" />
        <TextInput label="Max Forms" source="configuration.formtopia.max_forms" />
      </SimpleForm>
      {/* </ComponentWithDynamicResourceHeader> */}
    </Edit>
  )
}
